"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageScanner = void 0;

var CppObject_1 = require("./CppObject");

var instance_1 = require("./instance");

var Symbol_1 = require("./Symbol");

var ImageScanner = /*#__PURE__*/function (_CppObject_1$CppObjec) {
  _inherits(ImageScanner, _CppObject_1$CppObjec);

  function ImageScanner() {
    _classCallCheck(this, ImageScanner);

    return _possibleConstructorReturn(this, _getPrototypeOf(ImageScanner).apply(this, arguments));
  }

  _createClass(ImageScanner, [{
    key: "destroy",
    value: function destroy() {
      this.checkAlive();
      this.inst.ImageScanner_destory(this.ptr);
      this.ptr = 0;
    }
  }, {
    key: "setConfig",
    value: function setConfig(sym, conf, value) {
      this.checkAlive();
      return this.inst.ImageScanner_set_config(this.ptr, sym, conf, value);
    }
  }, {
    key: "enableCache",
    value: function enableCache() {
      var enable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.checkAlive();
      this.inst.ImageScanner_enable_cache(this.ptr, enable);
    }
  }, {
    key: "recycleImage",
    value: function recycleImage(image) {
      this.checkAlive();
      this.inst.ImageScanner_recycle_image(this.ptr, image.getPointer());
    }
  }, {
    key: "getResults",
    value: function getResults() {
      this.checkAlive();
      var res = this.inst.ImageScanner_get_results(this.ptr);
      return Symbol_1.Symbol.createSymbolsFromPtr(res, this.inst.memory.buffer);
    }
  }, {
    key: "scan",
    value: function scan(image) {
      this.checkAlive();
      return this.inst.ImageScanner_scan(this.ptr, image.getPointer());
    }
  }], [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var inst, ptr;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return instance_1.getInstance();

              case 2:
                inst = _context.sent;
                ptr = inst.ImageScanner_create();
                return _context.abrupt("return", new this(ptr, inst));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function create() {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return ImageScanner;
}(CppObject_1.CppObject);

exports.ImageScanner = ImageScanner;